interface Props {
    isOn: boolean;
    color: 'orange' | 'blue';
}

const Indicator = ({ isOn, color }: Props) => (
    <span data-testid="indicator" className={`indicator ${color} ${isOn && 'on'}`} />
);

export default Indicator;
